export type BepoFloatingPlayerFooterVariant = "podcast" | "sponsor"

interface BepoFloatingPlayerFooterProps {
    podcastName: string
    podcastImageUrl: string
    podcastPageUrl: string
    bepoHomeUrl?: string
    footerVariant?: BepoFloatingPlayerFooterVariant
}

export function BepoFloatingPlayerFooter(props: BepoFloatingPlayerFooterProps) {
    const { podcastName, podcastImageUrl, podcastPageUrl, bepoHomeUrl, footerVariant } = props

    if (footerVariant === "sponsor") {
        return (
            <div className="bepo-fp-footer bepo-fp-footer--sponsor">
                <a
                    className="bepo-fp-footer-sponsor-link"
                    href={bepoHomeUrl || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    בית הפודקאסטים של ישראל
                </a>
                <a
                    className="bepo-fp-footer-sponsor-logo-btn"
                    href={bepoHomeUrl || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="bepo"
                />
                <span className="bepo-fp-footer-sponsor-label">בחסות</span>
            </div>
        )
    }

    return (
        <div className="bepo-fp-footer">
            <div className="bepo-fp-footer-podcast-info">
                {podcastImageUrl && (
                    <img
                        className="bepo-fp-footer-podcast-image"
                        src={podcastImageUrl}
                        alt={podcastName}
                    />
                )}
                <span className="bepo-fp-footer-podcast-name">{podcastName}</span>
            </div>
            <a className="bepo-fp-footer-podcast-link" href={podcastPageUrl} target="_blank" rel="noopener noreferrer">
                <span className="bepo-fp-footer-link-text">לכל פרקי הפודקאסט</span>
                <span className="bepo-fp-footer-chevron" />
            </a>
        </div>
    )
}
